var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondocumple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f97e4e;\n      }\n\n      .cls-2 {\n        fill: #f2d0b1;\n      }\n\n      .cls-3 {\n        fill: #6c1b46;\n      }\n\n      .cls-4 {\n        fill: #840947;\n      }\n\n      .cls-5 {\n        fill: #59173e;\n      }\n\n      .cls-6 {\n        fill: #d5d3f8;\n      }\n\n      .cls-7 {\n        fill: #af3404;\n      }\n\n      .cls-8 {\n        opacity: .4;\n      }\n\n      .cls-9 {\n        fill: #eacf32;\n      }\n\n      .cls-10 {\n        fill: #b70950;\n      }\n\n      .cls-11 {\n        fill: #ffeb5c;\n      }\n\n      .cls-12 {\n        fill: #e24a00;\n      }\n\n      .cls-13 {\n        fill: #d80854;\n      }\n\n      .cls-14 {\n        fill: #ef6535;\n      }\n\n      .cls-15 {\n        fill: #d7d4ef;\n      }\n\n      .cls-16 {\n        fill: #fc5e27;\n      }\n\n      .cls-17 {\n        fill: #b9b8dd;\n      }\n\n      .cls-18 {\n        fill: #430a2d;\n      }\n\n      .cls-19 {\n        fill: #ff895a;\n      }\n\n      .cls-20 {\n        fill: #681d46;\n      }\n\n      .cls-21 {\n        fill: none;\n        stroke: #6c1b46;\n        stroke-miterlimit: 10;\n        stroke-width: .5px;\n      }\n\n      .cls-22 {\n        fill: #c4c4e8;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -25.48,
    y: -12.42,
    width: 1128.2,
    height: 1375.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 475.81,
    y: 1078.38,
    width: 563.59,
    height: 100.06,
    transform: "translate(-248.04 214.11) rotate(-13.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 722.43,
    y: 1078.38,
    width: 70.36,
    height: 100.06,
    transform: "translate(-248.04 214.11) rotate(-13.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 552.38,
    y: 1172.18,
    width: 513.56,
    height: 330.72,
    transform: "translate(-296.59 232.52) rotate(-13.85)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "578.62 1271.5 568.41 1280.56 567.43 1266.95 555.66 1260.04 568.3 1254.9 571.24 1241.57 580.03 1252.01 593.61 1250.68 586.4 1262.27 591.86 1274.78 578.62 1271.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "659.41 1251.59 649.2 1260.64 648.22 1247.03 636.46 1240.12 649.1 1234.98 652.03 1221.66 660.83 1232.09 674.41 1230.77 667.2 1242.35 672.66 1254.86 659.41 1251.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "740.21 1231.67 730 1240.73 729.02 1227.12 717.25 1220.21 729.89 1215.07 732.83 1201.74 741.62 1212.18 755.21 1210.85 748 1222.44 753.46 1234.95 740.21 1231.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "821 1211.76 810.8 1220.81 809.82 1207.2 798.05 1200.29 810.69 1195.15 813.63 1181.83 822.42 1192.26 836 1190.94 828.79 1202.52 834.25 1215.03 821 1211.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "901.8 1191.84 891.59 1200.9 890.61 1187.29 878.84 1180.38 891.49 1175.24 894.42 1161.91 903.22 1172.35 916.8 1171.02 909.59 1182.61 915.05 1195.12 901.8 1191.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "982.6 1171.93 972.39 1180.98 971.41 1167.37 959.64 1160.46 972.28 1155.32 975.22 1142 984.01 1152.43 997.59 1151.11 990.39 1162.69 995.84 1175.2 982.6 1171.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "878.02 1244.7 869.22 1234.26 866.29 1247.59 853.65 1252.73 865.41 1259.64 866.39 1273.25 876.6 1264.19 889.85 1267.47 884.39 1254.96 891.6 1243.37 878.02 1244.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "797.22 1264.61 788.43 1254.18 785.49 1267.5 772.85 1272.64 784.62 1279.55 785.6 1293.16 795.81 1284.11 809.05 1287.38 803.6 1274.87 810.8 1263.29 797.22 1264.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "959.15 1224.7 950.36 1214.26 950.27 1214.64 950.02 1214.34 947.09 1227.67 934.44 1232.81 946.21 1239.72 947.19 1253.33 947.51 1253.05 947.53 1253.25 957.59 1244.32 970.65 1247.55 970.56 1247.36 970.98 1247.47 965.53 1234.96 972.73 1223.37 959.15 1224.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "566.67 1347.13 561.21 1334.62 568.42 1323.03 554.83 1324.36 546.04 1313.92 543.1 1327.25 542.24 1327.6 547.53 1349.07 553.42 1343.85 566.67 1347.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "716.43 1284.53 707.63 1274.09 704.7 1287.42 692.05 1292.56 703.82 1299.47 704.8 1313.08 715.01 1304.02 728.26 1307.3 722.8 1294.79 730.01 1283.2 716.43 1284.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1040.87 1204.69 1039.95 1204.78 1031.15 1194.35 1028.22 1207.67 1015.58 1212.81 1027.34 1219.72 1028.32 1233.33 1038.53 1224.28 1046.17 1226.16 1040.87 1204.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "635.63 1304.44 626.84 1294.01 623.9 1307.33 611.26 1312.47 623.03 1319.38 624 1332.99 634.21 1323.94 647.46 1327.21 642 1314.7 649.21 1303.12 635.63 1304.44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "688.79 1370.79 678.58 1379.84 677.61 1366.23 665.84 1359.32 678.48 1354.19 681.42 1340.86 690.21 1351.29 703.79 1349.97 696.58 1361.56 702.04 1374.06 688.79 1370.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "769.59 1350.87 759.38 1359.93 758.4 1346.32 746.63 1339.41 759.28 1334.27 762.21 1320.94 771.01 1331.38 784.59 1330.05 777.38 1341.64 782.84 1354.15 769.59 1350.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "850.39 1330.96 840.18 1340.01 839.2 1326.4 827.43 1319.49 840.07 1314.35 843.01 1301.03 851.8 1311.46 865.38 1310.14 858.18 1321.72 863.63 1334.23 850.39 1330.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "931.18 1311.04 920.97 1320.1 919.99 1306.49 908.23 1299.58 920.87 1294.44 923.8 1281.11 932.6 1291.55 946.18 1290.22 938.97 1301.81 944.43 1314.32 931.18 1311.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1011.98 1291.13 1001.77 1300.18 1000.79 1286.57 989.02 1279.66 1001.67 1274.52 1004.6 1261.2 1013.39 1271.63 1026.98 1270.31 1019.77 1281.89 1025.23 1294.4 1011.98 1291.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "988.53 1343.9 979.74 1333.46 979.66 1333.85 979.4 1333.54 976.47 1346.87 963.82 1352.01 975.59 1358.92 976.57 1372.53 976.89 1372.25 976.91 1372.45 986.97 1363.52 1000.03 1366.75 999.95 1366.56 1000.37 1366.67 994.91 1354.16 1002.12 1342.57 988.53 1343.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1070.26 1323.89 1069.33 1323.98 1060.54 1313.55 1057.6 1326.87 1044.96 1332.01 1056.73 1338.92 1057.7 1352.53 1067.91 1343.48 1075.55 1345.36 1070.26 1323.89"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 778.48,
    y: 1172.18,
    width: 61.36,
    height: 330.72,
    transform: "translate(-296.59 232.52) rotate(-13.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M778.89,989.57h0c-10.59,2.61-18.82,10.06-22.58,20.44l-16.59,45.83-35.99-32.87c-8.15-7.44-18.9-10.22-29.49-7.61h0c-17.75,4.38-28.23,21.65-23.88,39.32,2.85,11.58,11.8,20.64,23.34,23.63l38,9.87,17.9-4.41,32.06-7.9,17.9-4.41,29.06-26.4c8.83-8.02,12.54-20.19,9.68-31.77-4.36-17.67-21.67-28.09-39.42-23.72ZM678.22,1060.92c-5.14-1.33-9.13-5.38-10.4-10.54h0c-2.14-8.68,3.57-15.8,10.72-17.56,4.29-1.06,9.11-.19,13.07,3.43l41.49,37.89-.34.95-54.53-14.17ZM800.86,1017.6c1.27,5.16-.39,10.59-4.32,14.16l-41.7,37.89-.75-.68,19.13-52.83c1.83-5.04,5.68-8.05,9.98-9.11,7.16-1.76,15.52,1.89,17.66,10.57h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 75.79,
    y: 1018.61,
    width: 263.97,
    height: 510.86,
    transform: "translate(-1081.61 1212.25) rotate(-77.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 195.82,
    y: 815.95,
    width: 99.54,
    height: 560.63,
    transform: "translate(-877.78 1108.43) rotate(-77.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 195.82,
    y: 1057.11,
    width: 99.54,
    height: 78.31,
    transform: "translate(-877.78 1108.43) rotate(-77.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 75.79,
    y: 1241.1,
    width: 263.97,
    height: 65.87,
    transform: "translate(-1081.61 1212.25) rotate(-77.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333.4,973.09h0c-11.91-2.53-23.81.95-32.64,9.55l-38.99,37.97-20.16-50.55c-4.57-11.45-14.02-19.47-25.93-22h0c-19.96-4.24-38.91,8.01-43.14,27.89-2.77,13.03,1.81,26.48,11.95,35.12l33.38,28.43,20.14,4.28,36.07,7.67,20.14,4.28,42.06-12.38c12.78-3.76,22.43-14.19,25.2-27.21,4.23-19.88-8.1-38.78-28.06-43.03ZM197.48,995.77c-4.51-3.84-6.56-9.85-5.33-15.65h0c2.08-9.76,11.28-14.14,19.33-12.43,4.83,1.03,9.24,4.24,11.46,9.81l23.24,58.28-.81.79-47.9-40.79ZM341.82,1011.95c-1.23,5.8-5.55,10.46-11.23,12.13l-60.36,17.77-.42-1.05,44.95-43.78c4.29-4.18,9.63-5.32,14.46-4.29,8.05,1.71,14.68,9.46,12.6,19.22h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -17.03,
    y: 827.97,
    width: 149.27,
    height: 276.86,
    transform: "translate(-898.87 816.67) rotate(-77.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-61.73 863.97 57.6 966.4 208.76 922.99 -61.73 863.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-9.25 824.03 -19.96 873.09 -24.87 895.61 57.6 966.4 162.07 936.4 166.99 913.88 177.69 864.82 -9.25 824.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.51,947.52h0c-3.3-.72-6.74-.05-9.53,1.85l-7.82,5.32-4.89-8.09c-1.75-2.89-4.6-4.93-7.9-5.65h0c-6.63-1.45-13.18,2.76-14.62,9.38h0c-1.14,5.21,0,10.65,3.13,14.96l16.89,23.28,25.05-14.13c4.64-2.62,7.94-7.09,9.08-12.3h0c1.45-6.63-2.76-13.18-9.38-14.62Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 12.52,
    y1: 854.17,
    x2: 145.34,
    y2: 883.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 7.89,
    y1: 875.37,
    x2: 140.72,
    y2: 904.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 3.27,
    y1: 896.56,
    x2: 136.1,
    y2: 925.54
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1123.66,1045.66l-12.53.69c-12.44.69-24.82-2.29-35.59-8.57l-168.08-97.91-13.36,22.93,167.95,97.6c10.92,6.34,19.72,15.79,25.26,27.14l5.45,11.15,30.89-53.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1079.73,1013.29l-21.64,37.14-133.95-78.43,21.64-37.14c8.49-14.57,27.25-19.52,41.82-11.03l81.09,47.64c14.57,8.49,19.52,27.25,11.03,41.82ZM1052.13,1027.83l13.31-22.86c3.9-6.7,1.63-15.31-5.07-19.22l-81.09-47.64c-6.7-3.9-15.31-1.63-19.22,5.07l-13.31,22.86,105.38,61.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M904.64,918.16l-99.18-120.32-85.22,146.28,153.58,26.93c10.53,1.85,21.09-3.06,26.47-12.3l6.7-11.51c5.38-9.24,4.44-20.85-2.36-29.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M758.58,950.85c16.36-7.88,35.36-27.11,50.36-52.85,15.12-25.95,22.47-52.18,21.11-70.32l-19.46-23.61c-3.05-.02-6.34.58-9.78,1.75l-76.06,130.56c.65,3.44,1.68,6.5,3.12,9.08l30.71,5.39Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 762.78,
    cy: 871.1,
    rx: 84.51,
    ry: 36.9,
    transform: "translate(-373.87 1091.71) rotate(-59.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M741.88,943.61c16.88-7.08,37.03-26.92,52.78-53.94,15.74-27.02,23.06-54.34,20.89-72.52-16.88,7.08-37.03,26.92-52.78,53.94-15.74,27.02-23.06,54.34-20.89,72.52Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "377.98 298.42 365.16 310.89 365.33 297.16 378.15 284.69 377.98 298.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "597.59 392.71 584.77 405.17 584.95 391.45 597.76 378.98 597.59 392.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "215.18 199.33 202.36 211.79 202.54 198.06 215.36 185.6 215.18 199.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "617.08 171.42 604.26 183.89 604.43 170.16 617.25 157.7 617.08 171.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "419.67 410.9 403.45 402.27 418.29 399.45 434.51 408.08 419.67 410.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "47.36 411.25 31.14 402.62 45.98 399.8 62.2 408.43 47.36 411.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "270.79 119.13 254.57 110.5 269.41 107.68 285.63 116.3 270.79 119.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "156.48 70.5 140.26 61.88 155.1 59.06 171.32 67.68 156.48 70.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "498.65 484.9 479.91 483.44 491.96 475.11 510.71 476.57 498.65 484.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "698.7 225.08 679.96 223.62 692.01 215.29 710.75 216.75 698.7 225.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "121.66 144.99 102.92 143.53 114.97 135.2 133.71 136.66 121.66 144.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "416.49 93.55 397.75 92.09 409.8 83.75 428.54 85.21 416.49 93.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "241.53 425.34 222.78 423.88 234.84 415.54 253.58 417 241.53 425.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "242.38 347.56 236.46 363.72 230.3 351.18 236.22 335.01 242.38 347.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "477.98 573.12 472.06 589.29 465.9 576.74 471.82 560.58 477.98 573.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "63.64 198.21 57.72 214.37 51.57 201.82 57.48 185.66 63.64 198.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "345.36 7.44 339.45 23.6 333.29 11.06 339.21 -5.11 345.36 7.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "441.64 199.12 435.73 215.29 429.57 202.74 435.49 186.58 441.64 199.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "265.14 273.35 249.35 264.1 264.31 261.86 280.1 271.12 265.14 273.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "280.03 708.74 264.24 699.48 279.2 697.25 294.99 706.51 280.03 708.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13.24 574.93 -2.55 565.67 12.41 563.44 28.2 572.7 13.24 574.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.96 334.5 28.18 325.24 43.14 323.01 58.93 332.27 43.96 334.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "324.36 163.44 308.57 154.18 323.54 151.95 339.33 161.21 324.36 163.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "138.16 370.8 145.81 386.35 150.57 373.32 142.92 357.76 138.16 370.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "257.69 535.6 265.34 551.15 270.1 538.12 262.45 522.56 257.69 535.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "489.1 113.49 496.76 129.04 501.51 116.01 493.86 100.45 489.1 113.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "851.98 211.45 859.63 227.01 864.39 213.97 856.74 198.41 851.98 211.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "601.55 289.34 619.99 285.95 606.96 278.92 588.53 282.31 601.55 289.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "915.1 497.17 933.54 493.78 920.51 486.75 902.07 490.14 915.1 497.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "852.3 151.7 870.74 148.31 857.71 141.28 839.28 144.67 852.3 151.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "953.72 106.87 972.16 103.48 959.13 96.45 940.69 99.84 953.72 106.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "496.59 305.08 514.84 309.21 506.44 297.78 488.19 293.65 496.59 305.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "999.25 198.09 1017.5 202.22 1009.09 190.79 990.84 186.66 999.25 198.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "745.96 417.46 764.21 421.59 755.8 410.16 737.55 406.03 745.96 417.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "150.87 660.67 169.12 664.8 160.71 653.37 142.46 649.24 150.87 660.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "818.6 32.93 836.85 37.06 828.44 25.64 810.19 21.51 818.6 32.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "773.06 343.65 772.86 360.68 783.19 350.62 783.39 333.59 773.06 343.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "995.7 254.95 995.5 271.97 1005.82 261.92 1006.03 244.89 995.7 254.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "128.65 493.69 128.45 510.71 138.78 500.66 138.98 483.63 128.65 493.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "878.56 39.4 878.36 56.43 888.68 46.37 888.89 29.35 878.56 39.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "669.8 61.29 669.6 78.32 679.92 68.27 680.12 51.24 669.8 61.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "778.17 266.78 796.42 262.66 783.07 256.15 764.81 260.26 778.17 266.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "965.41 389.64 983.66 385.52 970.31 379.01 952.05 383.12 965.41 389.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "577.42 485.32 595.68 481.2 582.32 474.69 564.07 478.81 577.42 485.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "761.59 145.41 779.84 141.29 766.49 134.78 748.24 138.89 761.59 145.41"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "922.19 282.71 998.48 187.22 1118.3 211.35 1022.28 -52.52 826.17 18.84 922.19 282.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "598.36 338.33 694.39 262.72 805.56 313.49 772.14 34.69 564.94 59.53 598.36 338.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.52 334.16 394.21 274.54 496.05 342.13 506.78 61.54 298.25 53.56 287.52 334.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "-17.32 264.81 100.12 230.95 183.97 319.87 258.05 49.02 56.76 -6.04 -17.32 264.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.9-28.13C96.07-1.14,193.9,29.44,312.2,45.83c187.5,25.98,459.86,19.62,759.35-129.87l9.21,9.13C777.06,77.77,500.6,84.38,310.51,58.04,188.42,41.13,87.7,9.16,17.47-18.61l9.44-9.52Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "590.66 1343.44 603.92 1256.48 425.76 1256.48 439.03 1343.44 590.66 1343.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "513.98 1256.48 513.98 1343.44 590.66 1343.44 603.92 1256.48 513.98 1256.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "524.18 1256.48 505.51 1256.48 508.06 1343.44 521.63 1343.44 524.18 1256.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "514.43 1256.48 514.43 1343.44 521.63 1343.44 524.18 1256.48 514.43 1256.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "439.28 1256.48 452.55 1343.44 466.33 1343.44 453.06 1256.48 439.28 1256.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "466.33 1256.48 479.59 1343.44 493.37 1343.44 482.65 1256.48 466.33 1256.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "590.4 1256.48 577.14 1343.44 563.36 1343.44 576.63 1256.48 590.4 1256.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "563.36 1256.48 550.1 1343.44 536.32 1343.44 547.04 1256.48 563.36 1256.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M431.7,1256.48c0-45.92,37.22-83.14,83.14-83.14s83.14,37.22,83.14,83.14h-166.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M443.42,1213.92c2.87.63,5.85.98,8.91.98,12.48,0,23.64-5.52,31.26-14.23,7.62,8.7,18.78,14.23,31.26,14.23s23.64-5.52,31.26-14.23c7.62,8.7,18.78,14.23,31.26,14.23,3.06,0,6.04-.35,8.91-.98-14.51-24.3-41.06-40.59-71.43-40.59s-56.92,16.28-71.43,40.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M514.43,1256.48h83.55c0-45.92-37.22-83.14-83.14-83.14-.14,0-.27,0-.41.01v83.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M514.84,1173.34c-.14,0-.27.01-.41.01v41.53c.14,0,.27.02.41.02,12.48,0,23.64-5.52,31.26-14.23,7.62,8.7,18.78,14.23,31.26,14.23,3.06,0,6.04-.35,8.91-.98-14.51-24.3-41.06-40.59-71.43-40.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M531.39,1167.19c0,9.14-7.41,16.54-16.54,16.54s-16.54-7.41-16.54-16.54,7.41-16.54,16.54-16.54,16.54,7.41,16.54,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M516.12,1155.31h-2.55v-7.57c0-9.26,3.6-17.96,10.15-24.5l1.8,1.8c-6.06,6.06-9.41,14.13-9.41,22.71v7.57Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondocumple);
export default __webpack_public_path__ + "static/media/fondo cumple.cd6aba137d49eb2ae47f5a50aed6acb6.svg";
export { ForwardRef as ReactComponent };